import React from "react";
import Sidebar from "../Sidebar/Sidebar";
import Navbar from "../Navbar/Navbar";
import { Outlet } from "react-router-dom";
import styles from "./CustomerDashboard.module.css";
// import useAuthGuard from "../../hooks/useAuthGuard";

const CustomerDashboard = () => {
  // useAuthGuard();
  return (
    <div className={styles.dashboardContainer}>
      <Sidebar isCustomer={true} />
      <div className={styles.mainContent}>
        <Navbar />
        <Outlet />
      </div>
    </div>
  );
};

export default CustomerDashboard;
